<template>
  <div id="shop-create-new">
    <div class="modal shop-create-new-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card has-text-left">
        <section class="modal-card-body">
          <p class="subtitle is-4 has-text-grey" style="margin: 0 0 6px">
            Create Business
          </p>
          <!-- <div class="notification"> -->
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select @change="selectCountry">
                  <option disabled selected value>
                    🏁 -- Select Country --
                  </option>
                  <option value="th">🇹🇭 Thailand</option>
                  <option value="sg">🇸🇬 Singapore</option>
                  <option value="mm">🇲🇲 Myanmar</option>
                  <option value="kh">🇰🇭 Cambodia</option>
                  <option value="my">🇲🇾 Malaysia</option>
                  <option value="vn">🇻🇳 Vietnam</option>
                  <option value="id">🇮🇩 Indonesia</option>
                  <option value="ph">🇵🇭 Philippines</option>
                  <option value="jp">🇯🇵 Japan</option>
                  <option value="pt">🇵🇹 Portugal</option>
                </select>
              </div>
            </div>
          </div>
          <!-- Google Location Input-->
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input
                class="input is-medium"
                v-model="locationInput"
                ref="autocomplete"
                placeholder="Location"
                onfocus="value = ''"
                type="text"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-globe-asia" />
              </span>
              <i
                class="icon is-small is-right"
                style="pointer-events: initial"
                @click="enterCoords"
              >
                <i class="far fa-edit fa-sm has-text-link" />
              </i>
            </p>
          </div>

          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input is-medium"
                v-model="businessName"
                type="text"
                placeholder="Business Name"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-font"></i>
              </span>
            </p>
          </div>

          <div class="control has-icons-left">
            <div class="select is-fullwidth is-medium">
              <select v-model="businessType">
                <option disabled selected value class="has-text-grey">
                  -- Select Type --
                </option>
                <option>Restaurant</option>
                <option>Shop</option>
                <option>Service</option>
                <option>Apartment</option>
                <!-- <option>Condominium</option> -->
                <option>Hotel</option>
                <!-- <option>Songthaew</option>
                        <option>Tuk Tuk</option>
                        <option>Sii Lor</option>
                        <option>Motocy</option>
                        <option>Taxi</option>
                        <option>Bar</option> -->
                <option>Other</option>
                <!-- <option>Travel Agency</option> -->
              </select>
            </div>
            <span class="icon is-small is-left">
              <i class="fas fa-store-alt"></i>
            </span>
          </div>

          <div v-show="fullAddress || lat">
            <div class="notification is-white has-text-left">
              <div v-if="fullAddress">
                <p>
                  <strong>Address:</strong>
                  {{ fullAddress }}
                </p>
                <p>
                  <strong>Phone:</strong>
                  {{ phoneNumber }}
                </p>
                <p>
                  <strong>URL:</strong>&nbsp;
                  <a :href="url" class="has-text-link">{{ shortURL }}</a>
                </p>
              </div>
              <div v-else style="padding-bottom: 8px">
                <i class="has-text-grey">
                  Manually entered coordinates.<br />
                  Remember to set address later.
                </i>
              </div>
            </div>
            <p class="control">
              <button class="button is-success is-fullwidth" @click="submit">
                Create
              </button>
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";

export default {
  name: "ShopCreateNew",
  data() {
    return {
      locationInput: "",
      autocomplete: undefined,
      place: undefined, // google place result
      fullAddress: "",
      phoneNumber: "",
      url: "",
      businessName: "", // name of business
      businessType: "", // type of business
      country: "th", // default to thailand
      lat: null, // previously used place.location.latitude()
      lon: null,
    };
  },
  computed: {
    shortURL() {
      var url = this.url;
      var split = url.split("//");
      if (split.length > 1) url = split[1];
      split = url.split("/");
      if (split.length > 1) url = split[0];
      return url;
    },
  },
  mounted() {
    var googlePlacesURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(googlePlacesURL, () => this.initGoogle());
  },
  methods: {
    closeModal() {
      this.locationInput = "";
      this.businessName = "";
      this.fullAddress = "";
      this.phoneNumber = "";
      this.url = "";
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    enterCoords() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map-marker-alt'></i>&nbsp;Enter coordinates
        </p>
        <p style='margin-bottom:12px'>
        You can manually enter the business' coordinates.
        </p>
         <p style='margin-bottom:12px'>
        Enter as <button>lat,lon</button>
        </p>
        </div>`,
        input: "text",
        inputPlaceholder: "18.739951,98.9316323",
        confirmButtonText: this.$t("submit"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: this.bulmaColor("info"),
        inputValidator: (txt) => {
          if (!txt || txt.length < 6 || txt.indexOf(",") === -1)
            return "Enter latitude,longitude";
        },
      }).then((val) => {
        if (val.value) {
          var nospace = val.value.replace(/ /g, "");
          var latString = nospace.split(",")[0];
          var lonString = nospace.split(",")[1];
          var lat = parseFloat(latString);
          var lon = parseFloat(lonString);
          var msg = `Incorrect format [ ${val.value} ] please enter latitude,longitude with no spaces.`;
          if (!lat || !lon) return this.errorToast(msg);
          var coords = lat + ", " + lon;
          this.infoToast(coords);
          this.locationInput = coords;
          // this.updateMarkerLocation([lat, lon], true);
          // this.businessName = place.name;
          // this.fullAddress = place.formatted_address;
          // this.phoneNumber = place.international_phone_number;
          // this.url = place.url;
          this.lat = lat;
          this.lon = lon;
          this.fullAddress = null;
          this.phoneNumber = null;
          this.url = null;
        }
      });
    },
    selectCountry(e) {
      this.country = e.target.value;
      this.initGoogle(); // re-init google with new country
    },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [], // uses all, options are ["address", "establishment", "geocode"]
          componentRestrictions: { country: this.country },
        }
      );
      this.geolocate();

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        this.businessName = place.name;
        this.fullAddress = place.formatted_address;
        this.phoneNumber = place.international_phone_number;
        this.url = place.url;
        // this.place = place;
        this.lat = place.geometry.location.lat();
        this.lon = place.geometry.location.lng();

        this.locationInput = place.types.join(", ");
        this.console(`The user picked ${name}`, place);
      });
    },
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    submit() {
      if (this.businessType === "") {
        alert("Missing Business Type");
        return;
      }
      try {
        // need to be logged in else error
        var loader = this.loadingDots("green");
        this.$store
          .dispatch("createBusiness", {
            name: this.businessName,
            business_type: this.businessType,
            phone_number: this.phoneNumber,
            address: this.fullAddress,
            created_by: this.$store.state.user.id,
            lat: this.lat, //this.place.geometry.location.lat(),
            lon: this.lon, //this.place.geometry.location.lng(),
            country: this.country, // default to Thailand and change later
          })
          .then((res) => {
            this.successToast("Business created!");
            this.goto("/business_profile/" + res.data.id);
            this.closeModal();
          })
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      } catch (err) {
        console.error("submit", err);
        alert("error on submit");
      }
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  padding: 10px;
  border-radius: 5px;
  max-width: 500px;
}
.notification {
  padding: 10px;
  margin-bottom: 0;
}
</style>